import { useMemo } from "react";

import { SWReactIcons } from "@similarweb/icons";
import type { DropdownTab } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import DropdownVirtualListContainer from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/TabbedDropdown/DropdownVirtualList/DropdownVirtualListContainer";
import type { TechnologiesDDItemType } from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";

import { StyledEmptyTabContainer, StyledText } from "./styles";

const TAB_INNER_HEIGHT = 260;

export type DropdownTabPanelProps<T> = {
    tab: DropdownTab<T>;
    onItemClick(item: T): void;
    isSingleSelect?: boolean;
    height?: number;
    tooltipForDisabledItem?: string;
};

const DropdownTabPanel = <T,>(props: DropdownTabPanelProps<T>) => {
    const translate = useTranslation();
    const { tab, onItemClick, isSingleSelect, height = TAB_INNER_HEIGHT, tooltipForDisabledItem } = props;

    const items = useMemo(() => {
        return tab.items.map((item) => item as TechnologiesDDItemType);
    }, [tab.items]);

    const handleItemClick = (item: TechnologiesDDItemType) => {
        onItemClick(item as T);
    };

    if (items.length === 0) {
        return (
            <StyledEmptyTabContainer height={height}>
                <SWReactIcons
                    iconName="no-search-results"
                    size="md"
                />
                <StyledText>
                    {translate("si.lead_gen_filters.technologies.dd_tab.empty_tab_text", {
                        name: tab.name.slice(0, tab.name.indexOf("(") - 1),
                    })}
                </StyledText>
            </StyledEmptyTabContainer>
        );
    }

    return (
        <DropdownVirtualListContainer
            itemHeight={48}
            items={items}
            onItemClick={handleItemClick}
            containerHeight={height}
            isSingleSelect={isSingleSelect}
            tooltipForDisabledItem={tooltipForDisabledItem}
        />
    );
};

export default DropdownTabPanel;
